import { TrustpilotExtended } from "modules/sections/AboveTheFold/Trustpilot";
import type { TrustpilotExtendedProps } from "modules/sections/AboveTheFold/Trustpilot";
import type { ReactStoryblokComponent } from "types/storyblok";

const TrustpilotExtendedAdapter = ({
  blok: { trustpilotVariant, reqlameAquiPosition, reqlameAquiScore, reqlameAquiStatus, showReqlameAqui = false },
}: ReactStoryblokComponent<TrustpilotExtendedProps>) => (
  <TrustpilotExtended
    trustpilotVariant={trustpilotVariant}
    showReqlameAqui={showReqlameAqui}
    reqlameAquiStatus={reqlameAquiStatus}
    reqlameAquiScore={reqlameAquiScore}
    reqlameAquiPosition={reqlameAquiPosition}
  />
);

export default TrustpilotExtendedAdapter;
